const KEY = 'md:identity:v1';

const ADJECTIVES = ['Quiet', 'Bright', 'Curious', 'Eager', 'Gentle', 'Bold', 'Calm', 'Swift', 'Patient', 'Keen'];
const ANIMALS = ['Otter', 'Sparrow', 'Fox', 'Hare', 'Lynx', 'Heron', 'Badger', 'Marten', 'Wren', 'Pika'];
const PALETTE = ['#6aa0ff', '#f0a04b', '#7cd982', '#c678dd', '#56b6c2', '#e06c75', '#d19a66', '#98c379'];

export interface Identity {
  name: string;
  color: string;
}

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function getIdentity(): Identity {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored) return JSON.parse(stored) as Identity;
  } catch { /* */ }
  const me: Identity = { name: `${pick(ADJECTIVES)} ${pick(ANIMALS)}`, color: pick(PALETTE) };
  try { localStorage.setItem(KEY, JSON.stringify(me)); } catch { /* */ }
  return me;
}

export function setIdentityName(name: string): Identity {
  const me = getIdentity();
  const next = { ...me, name };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* */ }
  return next;
}
